"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagBrIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagBrIcon = (0, _mobxReact.observer)(_class = (_FlagBrIcon = /*#__PURE__*/function (_React$Component) {
  function FlagBrIcon() {
    _classCallCheck(this, FlagBrIcon);
    return _callSuper(this, FlagBrIcon, arguments);
  }
  _inherits(FlagBrIcon, _React$Component);
  return _createClass(FlagBrIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FFF",
        d: "M0 0h100v100H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#000",
        d: "M0 11h100v13H0zM0 37h100v13H0zM0 63h100v13H0zM0 87h100v13H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FFF",
        d: "M0 0h54v50.6H0z"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(11 6)",
        fill: "#000"
      }, /*#__PURE__*/_react["default"].createElement("ellipse", {
        cx: "7.2",
        cy: "4.9",
        rx: "1.8",
        ry: "1"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M4.3 4.9c0-.5-.8-.9-1.8-.9s-1.8.4-1.8.9.8.9 1.8.9 1.8-.4 1.8-.9z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M6.1 10.8C6 7.3 5.5 4.6 4.8 4.4c.5 0 .9-.8.9-1.8S5.3.8 4.8.8s-.9.8-.9 1.8c0 .9.4 1.7.8 1.7-.7.1-1.2 2.8-1.3 6.4-.4.3-.8.8-1.3 1.4-.8 1.1-1.4 2.1-1.1 2.3.2.2 1.1-.6 1.9-1.7.2-.2.4-.5.5-.7v1.4c-.2.2-.4.5-.6.7-.8 1.1-1.4 2.1-1.1 2.3.2.2 1-.6 1.9-1.6.2 2.6.7 4.4 1.2 4.4s1-1.8 1.2-4.4c.8 1 1.6 1.7 1.8 1.6.2-.2-.3-1.2-1.1-2.3-.2-.3-.4-.5-.6-.7V12c.1.2.3.5.5.7.8 1.1 1.7 1.9 1.9 1.7.2-.2-.3-1.2-1.1-2.3-.4-.5-.9-1-1.3-1.3z"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(32 6)",
        fill: "#000"
      }, /*#__PURE__*/_react["default"].createElement("ellipse", {
        cx: "7.2",
        cy: "4.9",
        rx: "1.8",
        ry: "1"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M4.3 4.9c0-.5-.8-.9-1.8-.9s-1.8.4-1.8.9.8.9 1.8.9 1.8-.4 1.8-.9z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M6.1 10.8C6 7.3 5.5 4.6 4.8 4.4c.5 0 .9-.8.9-1.8S5.3.8 4.8.8 4 1.7 4 2.7c0 .9.4 1.7.8 1.7-.7.1-1.2 2.8-1.3 6.4-.4.3-.8.8-1.3 1.4-.8 1.1-1.4 2.1-1.1 2.3.2.2 1.1-.6 1.9-1.7.2-.2.4-.5.5-.7v1.4c-.2.2-.4.5-.6.7-.8 1.1-1.4 2.1-1.1 2.3.2.2 1-.6 1.9-1.6.2 2.6.7 4.4 1.2 4.4s1-1.8 1.2-4.4c.8 1 1.6 1.7 1.8 1.6.2-.2-.3-1.2-1.1-2.3-.2-.3-.4-.5-.6-.7v-1.4c.1.2.3.5.5.7.8 1.1 1.7 1.9 1.9 1.7.2-.2-.3-1.2-1.1-2.3-.5-.6-1-1.1-1.4-1.4z"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(11 35)",
        fill: "#000"
      }, /*#__PURE__*/_react["default"].createElement("ellipse", {
        cx: "7.2",
        cy: "4.9",
        rx: "1.8",
        ry: "1"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M4.3 4.9c0-.5-.8-.9-1.8-.9s-1.8.4-1.8.9.8.9 1.8.9 1.8-.4 1.8-.9z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M6.1 10.8C6 7.3 5.5 4.6 4.8 4.4c.5 0 .9-.8.9-1.8S5.3.8 4.8.8s-.9.8-.9 1.8c0 .9.4 1.7.8 1.7-.7.1-1.2 2.8-1.3 6.4-.4.3-.8.8-1.3 1.4-.8 1.1-1.4 2.1-1.1 2.3.2.2 1.1-.6 1.9-1.7.2-.2.4-.5.5-.7v1.4c-.2.2-.4.5-.6.7-.8 1.1-1.4 2.1-1.1 2.3.2.2 1-.6 1.9-1.6.2 2.6.7 4.4 1.2 4.4s1-1.8 1.2-4.4c.8 1 1.6 1.7 1.8 1.6.2-.2-.3-1.2-1.1-2.3-.2-.3-.4-.5-.6-.7V12c.1.2.3.5.5.7.8 1.1 1.7 1.9 1.9 1.7.2-.2-.3-1.2-1.1-2.3-.4-.5-.9-1-1.3-1.3z"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(32 35)",
        fill: "#000"
      }, /*#__PURE__*/_react["default"].createElement("ellipse", {
        cx: "7.2",
        cy: "4.9",
        rx: "1.8",
        ry: "1"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M4.3 4.9c0-.5-.8-.9-1.8-.9s-1.8.4-1.8.9.8.9 1.8.9 1.8-.4 1.8-.9z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M6.1 10.8C6 7.3 5.5 4.6 4.8 4.4c.5 0 .9-.8.9-1.8S5.3.8 4.8.8 4 1.7 4 2.7c0 .9.4 1.7.8 1.7-.7.1-1.2 2.8-1.3 6.4-.4.3-.8.8-1.3 1.4-.8 1.1-1.4 2.1-1.1 2.3.2.2 1.1-.6 1.9-1.7.2-.2.4-.5.5-.7v1.4c-.2.2-.4.5-.6.7-.8 1.1-1.4 2.1-1.1 2.3.2.2 1-.6 1.9-1.6.2 2.6.7 4.4 1.2 4.4s1-1.8 1.2-4.4c.8 1 1.6 1.7 1.8 1.6.2-.2-.3-1.2-1.1-2.3-.2-.3-.4-.5-.6-.7v-1.4c.1.2.3.5.5.7.8 1.1 1.7 1.9 1.9 1.7.2-.2-.3-1.2-1.1-2.3-.5-.6-1-1.1-1.4-1.4z"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagBrIcon.defaultProps = {
  width: '20px'
}, _FlagBrIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagBrIcon);